import { Tab, Tabs } from "react-bootstrap";
import { useEffect, useState } from "react";
import apiService from "Services/apiService";
import TableRender from "components/common/TableRender/TableRender"
import { SkeTable } from "components/common/Skeleton/SkeTable";
import Search from "components/common/Search/Search";
import polizaImg from "assets/img/polizasStock.svg";
import { formatDate } from "Utils/Fn/DateParser";
import Button from "components/common/Button/Button";
import ModalReports from "components/common/Modals/ModalReport";

import { DynamicRow } from "Interface/generic.model";
import e from "./style.module.css";
import ModalBilling from "./Modal/ModalBilling";
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";

export const BillingList = () => {
  
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [allBilling, setAllBilling] = useState<any[]>([]);
  const [billing, setBilling] = useState<any[]>([]);
  const [show, setShow] = useState(false);
  const [selectedElement, setSelectedElement] = useState<any>(null);
  const [disableBtn] = useState<boolean>(false);
  const [showMReports, setShowMReports] = useState(false);


  const BILLING_TABLE_ROWS = [
    {label: 'Código', key: 'codCuentasxCobrar'},
    {label: 'Fecha facturación', key: '_date'},
    {label: 'Nro. Doc.', key: 'nroDoc'},
    {label: 'Póliza', key: 'nroPoliza'},
    {label: 'Aseguradora', key: 'aseguradora'},
    {label: 'Tipo', key: 'tipoCuentas'},
    {label: 'Fecha Doc.', key: '_star_date'},
    {label: 'Vence', key: '_due_date'},
    {label: 'Monto pendiente', key: 'amount', class: 'text-right', classBody: 'text-right'},
    {label: 'Facturación', key: 'tipoFacturacion'},
    {label: 'Gestor', key: 'gestorCobros'},
    {label: 'Pagos', key: 'paymentSlot', slotName: 'paymentSlot'}
  ];

  const handleClose = () => setShow(false);


  useEffect(() => {
    apiService({
      name: 'getBillingCop',
      queryParams: {_codigoCliente: JSON.parse(localStorage.getItem('cliCod') || 'null')},
      onSuccess: ({response}) => {
        setLoading(false);
        const resp = response.map((data: any) => (
          {...data,
            id: data.codigo,
            _date: formatDate(data.fecPagos),
            _due_date: formatDate(data.fecVencimiento),
            _star_date: formatDate(data.fecDocumento),
            amount: '$' + data.montoPendiente
          }
        ));
        setAllBilling(resp);
        setBilling(resp);
      },
      onError: (error) => {
        setLoading(false);
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener datos',
          details: error,
          variant: 'Danger'
        })
      },
    });
  }, []);

  const paymentSlotBtn = (row: DynamicRow) => {
    return (
      <button
        type="button"
        id={row.id}
        className={`btn btn-link primary-text ${e['btn_slot-modal']}`}
        onClick={() => openModal(row)}
      >
        Ver detalles
      </button>
    );
  };
  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const openModal = (selectData: DynamicRow) => {
    setSelectedElement(selectData);
    setShow(true);
  };

  const filterBy = (fil: string, searchValue: string) => {
    if (searchValue === "") {
      setAllBilling(billing);
    } else {
      setAllBilling(
        billing.filter((item) => {
          if (item.hasOwnProperty(fil)) {
            const value = item[fil];
            return value && value.toString().toLowerCase().includes(searchValue.toLowerCase());
          }
          return false;
        })
      );
    }
  };

  return (
    <>
      <div className="container pb-3">
        <section className="row">
          <div className="col-md-3">

            <img
              src={polizaImg}
              alt="Imagen vector de archivo con folder"
              className={e.img_polizas}
            />
          </div>
          <div className="col-md-9 text-center text-md-start">
            <h3>Facturación</h3>
            <p className="mb-1">Consulta de facturas y pagos realizados.</p>
            <div className="d-flex justify-content-center justify-content-md-start">
              <span className="deco_line" />
            </div>
            <div className="d-flex justify-content-center justify-content-md-start justify-content-lg-end">
              <Button type="button" onClick={() => setShowMReports(true)} disabled={disableBtn} showLoading={true} value="Generar Reporte" className="px-3 py-2 mt-2 mt-lg-0"/>
            </div>
            <div className="row mt-3 mt-md-5 px-3 p-md-1">
              <div className="col-lg-4">
                <Search
                  onChange={(e) => filterBy("nroPoliza", e.target.value)}
                  label="Buscar por número de póliza"
                  placeholder="Número de póliza"
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={`pt-4 pb-5 container-fluid ${e.table_ctn}`}>
        <div className="container">
        <Tabs
          defaultActiveKey="accounts"
          id="tab-BillingList"
          className="mb-3"
        >
          <Tab eventKey="accounts" title="Cuentas por cobrar">
            {loading ? (
              <SkeTable
                col={13}
                row={10}
                className="pt-1"
              />
            ) : (
              <div className={e['table-container']}>
                <TableRender
                  id="BillinListTable"
                  schema={BILLING_TABLE_ROWS}
                  rows={allBilling}
                  slots={{
                    'paymentSlot': paymentSlotBtn
                  }}
                />
              </div>
              
            )}
          </Tab>
        </Tabs>
        </div>
      </div>
      <ModalReports  show={showMReports} handleClose={() => setShowMReports(false)} mData={{name: 'downloadBillingReportByDate', docName: 'Facturación', docExt: 'xlsx'}}/>
      <ModalBilling
        show={show}
        handleClose={handleClose}
        mData={selectedElement}
      />
      <AlertNotification
          show={alert?.show}
          title= {alert?.title}
          details= {alert?.details}
          variant={alert?.variant}
          onClose={resetAlert}
      />
    </>
  );
};
